const TALENT_SSO = 'https://crehana.acsendo.com/rest/saml3/login?next=';
export const ACSENDO_DOMAIN = `${TALENT_SSO}https://crehana.acsendo.com`;
